/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  TravelPreferencesResponse,
  TravelPreferencesUpdateRequest,
  TravelerProfileUpdateRequest,
} from '../models/index';
import {
    TravelPreferencesResponseFromJSON,
    TravelPreferencesResponseToJSON,
    TravelPreferencesUpdateRequestFromJSON,
    TravelPreferencesUpdateRequestToJSON,
    TravelerProfileUpdateRequestFromJSON,
    TravelerProfileUpdateRequestToJSON,
} from '../models/index';

export interface TravelPreferencesPatchRequest {
    travelPreferencesUpdateRequest: TravelPreferencesUpdateRequest;
}

export interface TravelPreferencesProfilePatchRequest {
    travelerProfileUpdateRequest: TravelerProfileUpdateRequest;
}

/**
 * 
 */
export class UserApi extends runtime.BaseAPI {

    /**
     * Get the current user\'s travel preferences and auto-generated traveler profile summary.
     */
    async travelPreferencesGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TravelPreferencesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/travel-preferences`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TravelPreferencesResponseFromJSON(jsonValue));
    }

    /**
     * Get the current user\'s travel preferences and auto-generated traveler profile summary.
     */
    async travelPreferencesGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TravelPreferencesResponse> {
        const response = await this.travelPreferencesGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update the current user\'s travel preferences (free-text).
     */
    async travelPreferencesPatchRaw(requestParameters: TravelPreferencesPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TravelPreferencesResponse>> {
        if (requestParameters['travelPreferencesUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'travelPreferencesUpdateRequest',
                'Required parameter "travelPreferencesUpdateRequest" was null or undefined when calling travelPreferencesPatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/travel-preferences`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: TravelPreferencesUpdateRequestToJSON(requestParameters['travelPreferencesUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TravelPreferencesResponseFromJSON(jsonValue));
    }

    /**
     * Update the current user\'s travel preferences (free-text).
     */
    async travelPreferencesPatch(requestParameters: TravelPreferencesPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TravelPreferencesResponse> {
        const response = await this.travelPreferencesPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the current user\'s LLM-learned traveler profile.
     */
    async travelPreferencesProfilePatchRaw(requestParameters: TravelPreferencesProfilePatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TravelPreferencesResponse>> {
        if (requestParameters['travelerProfileUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'travelerProfileUpdateRequest',
                'Required parameter "travelerProfileUpdateRequest" was null or undefined when calling travelPreferencesProfilePatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/travel-preferences/profile`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: TravelerProfileUpdateRequestToJSON(requestParameters['travelerProfileUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TravelPreferencesResponseFromJSON(jsonValue));
    }

    /**
     * Update the current user\'s LLM-learned traveler profile.
     */
    async travelPreferencesProfilePatch(requestParameters: TravelPreferencesProfilePatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TravelPreferencesResponse> {
        const response = await this.travelPreferencesProfilePatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
